// Canonical app identifiers, matching the `app` column in the InstanceSetting
// table. Only the apps listed here are subject to instance-level enablement
// gating; any route not mapped to one of these IDs is never enablement-checked.

export const APP_IDS = {
  CANDISPATCH: 'candispatch',
  CANVISION: 'canvision',
  CANPARK: 'canpark',
  CANSHARE: 'canshare',
  CANTRACK: 'cantrack',
  CANMAIL: 'canmail',
  CANMEET: 'canmeet',
  CANSURVEY: 'cansurvey',
  CANAI: 'canai',
} as const;

export type AppId = (typeof APP_IDS)[keyof typeof APP_IDS];

// The set of app IDs that require an instance-level `enabled` entitlement.
export const GATED_APPS: ReadonlySet<AppId> = new Set(Object.values(APP_IDS));
